module.exports = __webpack_public_path__ + "img/12-presidente.16ed11db.png";